import { Directive, HostBinding, inject } from '@angular/core';
import { Router } from '@angular/router';
import { EnvironmentService } from '@big-direkt/utils/environment';

@Directive({
    selector: '[bigUiHeadingStyle]',
})
export class HeadingStyleDirective {
    private readonly router = inject(Router);
    private readonly environmentService = inject(EnvironmentService);

    @HostBinding('class') public get hostClasses(): string {
        const { privatePath } = this.environmentService;

        if (privatePath && this.router.url.startsWith(privatePath)) {
            return 'text-center';
        }

        return 'text-left';
    }
}
